@if (product$ | async; as product) {
  <ul class="row">
    @for (
      bimModel of product.bimDocuments;
      track bimModel;
      let innerIndex = $index
    ) {
      <li class="col col-xl-3 col-lg-5 col-md-12 col-sm-12">
        <boels-bim-model-list-item
          [bimDocument]="bimModel"
        ></boels-bim-model-list-item>
      </li>
    }
  </ul>
}
